import type { ComponentPropsWithoutRef } from "react";
import { Badge } from '@startupquickstart/frontend';

type AttractionStatus = 'published' | 'draft' | 'needs_review';

interface AttractionStatusBadgeProps extends Omit<ComponentPropsWithoutRef<typeof Badge>, 'variant'> {
  status: AttractionStatus;
}

function getStatusConfig(status: AttractionStatus) {
  switch (status) {
    case 'published':
      return {
        variant: 'default' as const,
        label: 'Published',
      };
    case 'draft':
      return {
        variant: 'secondary' as const,
        label: 'Draft',
      };
    case 'needs_review':
      return {
        variant: 'destructive' as const,
        label: 'Needs Review',
      };
    default:
      return {
        variant: 'outline' as const,
        label: 'Unknown',
      };
  }
}

export function AttractionStatusBadge({ status, className, ...props }: AttractionStatusBadgeProps) {
  const { variant, label } = getStatusConfig(status);

  return (
    <Badge variant={variant} className={className} {...props}>
      {label}
    </Badge>
  );
}
